import { render, staticRenderFns } from "./DesignCheckBox.vue?vue&type=template&id=0a6af8f6&scoped=true&"
import script from "./DesignCheckBox.vue?vue&type=script&lang=js&"
export * from "./DesignCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6af8f6",
  null
  
)

export default component.exports